import * as Yup from 'yup';

import { FULL_NAME_REGEX } from '@utils/constants';
import validateSubscriptionEmail from '@utils/validateSubscriptionEmail';

const validationSchema = (isYPPlan: boolean) =>
  Yup.object()
    .shape({
      email: validateSubscriptionEmail(),
      name: Yup.string()
        .matches(FULL_NAME_REGEX, 'Please enter a full name with at least a first and last name')
        .required('Full name is required'),
      month: Yup.object().shape({
        value: Yup.number(),
        label: Yup.string(),
      }),
      day: Yup.object().shape({
        value: Yup.number(),
        label: Yup.number(),
      }),
      year: Yup.object().shape({
        value: Yup.number(),
        label: Yup.number(),
      }),
    })
    .test('dob-required', null, (schema) => {
      const { month, day, year } = schema;
      if ((month.value > 0 && day.value > 0 && year.value > 0) || !isYPPlan) return true;

      return new Yup.ValidationError('Date of birth is required.', null, 'dob');
    })
    .test('is-dob-valid', 'This plan is only available for people 30 or under.', (schema) => {
      if (!isYPPlan) return true;
      const { month, day, year } = schema;
      const birthday = new Date(year.value, month.value - 1, day.value);
      const cutoff = new Date();
      cutoff.setFullYear(cutoff.getFullYear() - 31);
      if (birthday > cutoff) return true;

      return new Yup.ValidationError(
        'This plan is only available for people 30 or under.',
        null,
        'dob'
      );
    });

export default validationSchema;
